import { useState } from 'react'
import FsLightbox from 'fslightbox-react'

import type { SoftwareSchema } from 'openapi'
import { resizeImgUrl } from 'utils/resizeImgUrl'
import { cn } from 'utils/cn'

type Props = {
  software: SoftwareSchema
  className?: string
}

/**
 * Displays software cover image with lightbox functionality for full-size viewing
 */
export function SoftwareScreenshots(props: Props) {
  const { software } = props
  const [toggler, setToggler] = useState(false)

  const className = cn('bg-gray-1200 w-full max-h-96 flex-shrink-0 cursor-pointer', props.className)

  return (
    <>
      <div className={className} onClick={() => setToggler(!toggler)}>
        <img
          src={resizeImgUrl(software.cover, '1200px')}
          alt={`${software.name} cover`}
          className="w-auto h-full max-h-96 object-contain mx-auto shadow-md"
        />
      </div>
      <FsLightbox toggler={toggler} sources={[software.cover!]} types={['image']} />
    </>
  )
}
